
import { ronMediaArray } from './ronMedia'
import { hermioneReviewerProfile, dumbledoreReviewerProfile, harryReviewerProfile } from './ronReviewers'
import { ronBio, hermioneBio, dumbledoreBio, harryBio } from './ronBios'
import { ronDatingProfileHinge, ronDatingProfileBumble, ronDatingProfileTinder } from './ronDatingProfiles'

export const ronUser = {
  _id: 'ronUserId',
  email: 'ron@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...hermioneReviewerProfile },
    { ...dumbledoreReviewerProfile },
    { ...harryReviewerProfile }
  ],
  media: [ ...ronMediaArray ],
  bio: { ...ronBio },
  datingProfiles: [
    { ...ronDatingProfileHinge },
    { ...ronDatingProfileBumble },
    { ...ronDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const hermioneUser = {
  _id: 'hermioneUserId',
  email: 'hermione@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...hermioneBio },
  datingProfiles: [],
  reviewerProfile: { ...hermioneReviewerProfile },
}

export const dumbledoreUser = {
  _id: 'dumbledoreUserId',
  email: 'dumbledore@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...dumbledoreBio },
  datingProfiles: [],
  reviewerProfile: { ...dumbledoreReviewerProfile },
}

export const harryUser = {
  _id: 'harryUserId',
  email: 'harry@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...harryBio },
  datingProfiles: [],
  reviewerProfile: { ...harryReviewerProfile },
}
